var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRigthArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 9,
    viewBox: "0 0 40 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84853 4.46306C4.84853 5.80194 3.76315 6.88731 2.42427 6.88731C1.08538 6.88731 0 5.80194 0 4.46306C0 3.12419 1.08538 2.03882 2.42427 2.03882C3.76315 2.03882 4.84853 3.12419 4.84853 4.46306Z",
    fill: "#196BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1086 0.177421C35.3452 -0.0592 35.7289 -0.0590809 35.9656 0.177421L39.8228 4.03455C40.0595 4.27123 40.0595 4.65488 39.8228 4.89156L35.9656 8.74869C35.7289 8.98519 35.3452 8.98531 35.1086 8.74869C34.872 8.51207 34.8721 8.12838 35.1086 7.89168L37.9312 5.06912H3.03027V3.85699H37.9312L35.1086 1.03443C34.8721 0.797734 34.872 0.414043 35.1086 0.177421Z",
    fill: "#196BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRigthArrow);
export default __webpack_public_path__ + "static/media/rigthArrow.defb3e35cda11946e3801a5664af1ae1.svg";
export { ForwardRef as ReactComponent };